module.exports = __webpack_public_path__ + "static/img/6-3.b355c00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/6-3.jpg
// module id = +94M
// module chunks = 0